/**
 * Константы для работы с доставкой
 */

/**
 * Типы доставки
 */
export const DELIVERY_TYPES = {
    FAST: 'fastDelivery',
    COURIER: 'courier',
    PICKUP: 'pickup',
    OUTPOINT: 'outpoint',
} as const;

/**
 * Названия cookies для доставки
 */
export const DELIVERY_COOKIES = {
    DELIVERY_STATE: 'productDeliveryState',
    LAST_CHECKED: 'productDeliverylastChecked',
    PICKUP_POINT: 'selectedPickupPoint',
} as const;

/**
 * Параметры для API доставки
 */
export const DELIVERY_API_PARAMS = {
    IS_FAST: 'is_fast',
    ONLY_FAST: 'only_fast',
    DELIVERY_WAREHOUSE: 'delivery_warehouse',
    GOOD_CODE: 'good_code',
    MAIN_GOOD_CODE: 'main_good_code',
} as const;

/**
 * Endpoints API доставки
 */
export const DELIVERY_API_ENDPOINTS = {
    AVAILABLE_STORES: '/deliveryapi/api/available/stores/',
} as const;

/**
 * Время хранения cookies (в днях)
 */
export const COOKIE_EXPIRY = {
    DELIVERY_STATE: 30, // 30 дней
    LAST_CHECKED: 3, // 3 дня
    PICKUP_POINT: 30, // 30 дней
} as const;

/**
 * Тексты для UI
 */
export const DELIVERY_TEXTS = {
    FAST_DELIVERY: {
        AVAILABLE: 'Экспресс доставка до 3 часов:',
        AVAILABLE_AT_ADDRESS:
            'Экспресс доставка по указанному адресу доступна!',
        UNAVAILABLE: 'Экспресс доставка недоступна по адресу',
        UNAVAILABLE_SORRY:
            'К сожалению, экспресс доставка недоступна по вашему адресу',
        SELECT_REGION: 'выберите регион',
        DEFAULT_TIME: 'за 3 часа',
        TOMORROW: 'завтра',
    },
    STANDARD_DELIVERY: {
        ONLY_STANDARD:
            'По указанному адресу доступна только стандартная доставка',
        UNAVAILABLE_AT_ADDRESS: 'По указанному адресу, доставка недоступна',
    },
    ADDRESS: {
        ENTER_OR_POINT: 'Введите адрес или укажите точку на карте',
    },
    DATE: {
        TODAY: 'Сегодня',
        TOMORROW: 'Завтра',
        DAY_AFTER: 'Послезавтра',
        CLARIFY: 'Уточнить',
    },
    ALERT: {
        SEARCHING: 'Ищем ближайший магазин для быстрой доставки…',
        SUCCESS: 'Магазин найден, условия доставки обновлены',
        FAIL: 'К сожалению, экспресс доставка недоступна по вашему адресу',
    },
} as const;

/**
 * Сообщения об ошибках
 */
export const ERROR_MESSAGES = {
    ADDRESS_HINTS_FAILED: 'Не смогли загрузить подсказки адресов',
    GEOCODE_FAILED: 'Не удалось определить координаты',
    DELIVERY_CHECK_FAILED: 'Не удалось проверить доступность доставки',
} as const;
